import { AlloyLegacyThemeDesignTokens, ToggleDesignTokens } from '../types';
import { WeaveTheme } from '../types/weaveTypes';

type WeaveTokens = WeaveTheme['tokens'];

export const getToggleTokensAlloy = (
  theme: AlloyLegacyThemeDesignTokens,
  transitionDuration: number,
  transitionEasing: string,
): ToggleDesignTokens => ({
  'border-color': theme.tokens.colors.border.value,
  'border-radius': theme.borderRadius.pill,
  checked: {
    'background-color': theme.tokens.colors.background.selected.value,
    disabled: {
      'background-color':
        theme.tokens.colors.background.selected.inactive.value,
    },
  },
  disabled: {
    'border-color': theme.tokens.colors.border.inactive.value,
  },
  thumb: {
    'background-color': theme.tokens.colors.background.inverse.subtler.value,
    'border-radius': theme.borderRadius.circle,
    checked: {
      'background-color': theme.tokens.colors.background.primary.value,
    },
    disabled: {
      'background-color': theme.tokens.colors.background.neutral.inactive.value,
    },
  },
  interactive: {
    transition: `box-shadow ${transitionDuration}ms ${transitionEasing}, border-color ${transitionDuration}ms ${transitionEasing}`,
    hover: {
      'box-shadow': theme.halos.hover,
    },
    'focus-within': {
      'box-shadow': theme.halos.focus,
    },
    active: {
      'box-shadow': theme.halos.active,
      'border-color': theme.colors.charcoal500,
    },
    disabled: {
      cursor: 'not-allowed',
      'box-shadow': 'none',
    },
  },
});

export const getToggleTokensWeave = (
  tokens: WeaveTokens,
): ToggleDesignTokens => {
  const toggle = tokens?.component?.toggle;
  const track = toggle?.track;
  const thumb = toggle?.thumb;

  const buildBoxShadow = (state: 'focus' | 'hover' | 'pressed') =>
    `${track?.['box-shadow-x']?.[state] || '0px'} ${track?.['box-shadow-y']?.[state] || '0px'} ${track?.['box-shadow-blur']?.[state] || '0px'} ${track?.['box-shadow-spread']?.[state] || '2px'} ${track?.['box-shadow-color']?.[state] || 'transparent'}`;

  return {
    'border-color': track?.['border-color']?.default,
    'border-radius': toggle?.['border-radius'],
    checked: {
      'background-color': track?.['background-color']?.selected,
      disabled: {
        'background-color': track?.['background-color']?.selected,
      },
    },
    disabled: {
      'border-color': track?.['border-color']?.default,
    },
    thumb: {
      'background-color': thumb?.['background-color']?.default,
      'border-radius': toggle?.['border-radius'],
      checked: {
        'background-color': thumb?.['background-color']?.selected,
      },
      disabled: {
        'background-color': thumb?.['background-color']?.default,
      },
    },
    opacity: {
      disabled: toggle?.opacity?.disabled,
    },
    interactive: {
      transition:
        'box-shadow 200ms cubic-bezier(0.2, 0, 0.2, 1), border-color 200ms cubic-bezier(0.2, 0, 0.2, 1)',
      hover: {
        'box-shadow': buildBoxShadow('hover'),
      },
      'focus-within': {
        'box-shadow': `0px 0px 0px 0px white, ${buildBoxShadow('focus')}`,
      },
      active: {
        'box-shadow': buildBoxShadow('pressed'),
      },
      disabled: {
        cursor: 'not-allowed',
        'box-shadow': 'none',
      },
    },
  };
};
